import { data } from 'jquery';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ServiceService } from '../../masterservice/service.service';
import { DropdownService } from '@planwork/services/dropdown.service';

@Component({
  selector: 'app-global-modal',
  templateUrl: './global-modal.component.html',
  styleUrls: ['./global-modal.component.scss']
})
export class GlobalModalComponent implements OnInit {
  modalTitle: any;
  action: any;
  InputData: any;
  categorylist: any[] = [];
  SBHDropDownLists: any = [];
  tree35 = '';
  ProjectCategoryInput: any = {
    LeadCategoryName: '',
    IsApproved: "true",
    CostCenterCategory: {
      StrategicBusinessHead: {
        EmployeeName: ''
      }
    }
  };
  ProjectTypeDropDownLists: any;
  HsnDropList: any[] = [];
  vendorServiceNameList: any[] = [];
  response: any;
  constructor(
    public dialogRef: MatDialogRef<GlobalModalComponent>,
    public dialog:MatDialog,
    private dropdownService: DropdownService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private spinner: NgxSpinnerService,
    private coreservice: ServiceService,

  ) {
    this.modalTitle = data.modalTitle || '';
    this.action = data.action || '';
    if(this.action == 'EditProjectCategory'){
      this.ProjectCategoryInput = data.data || {};
    }else{
      this.InputData = data.data || {};
    }

     if(this.action == 'AddKeyFeature' || this.action == 'EditKeyFeature'){
      this.InputData = data.data || {};
    }
    if(this.action == 'AddBufferPercentage' || this.action == 'EditBufferPercentage'){
      this.InputData = data.data || {};
    }
    if(this.action == 'AddEstimationBuffer' || this.action == 'EditBufferPercentage'){
      this.InputData = data.data || {};
    }
    if(this.action == 'AddPurposeOfTravel' || this.action == 'EditPurposeOfTravel'){
      this.InputData = data.data || {};
    }
  }


  closeModal(data:any = false){
    this.dialogRef.close(data);
  }

  categorydropdown(): void {
    this.spinner.show()
    this.coreservice.compliencesdropdown({ ISGoverment: false,IsAll:true }, 'CompliancesCategoryDropDownList').subscribe(res => {
      this.categorylist = res.body
      this.spinner.hide()
    })
  }
  GetProjectCategoryDropDown(): Promise<any> {
    return this.dropdownService.GetProjectCategoryDropDownList({}).toPromise()
  }
  GetvendorServiceNameList(): Promise<any> {
    let payload = {"Search":{"draw":1,"columns":[{"data":"#","name":"","searchable":true,"orderable":true,"search":{"value":"","regex":false}},{"data":"ServiceCategory","name":"","searchable":true,"orderable":true,"search":{"value":"","regex":false}},{"data":"Created On","name":"","searchable":true,"orderable":true,"search":{"value":"","regex":false}},{"data":"","name":"","searchable":true,"orderable":true,"search":{"value":"","regex":false}}],"order":[{"column":0,"dir":"desc"}],"start":0,"length":1000000,"search":{"value":"","regex":false},"value":""}}
    return this.dropdownService.GetvendorServiceNameList(payload).toPromise()
  }
  SBHDropDown(): Promise<any> {
    return this.dropdownService.SBHDropDownList({}).toPromise()
  }
  getSBHName(event) {
    this.ProjectCategoryInput.CostCenterCategory.StrategicBusinessHead = event.value.StrategicBusinessHead;
  }

  async ngOnInit(): Promise<void> {
    if (this.action == 'AddComplianceSubcategory' || this.action == 'EditComplianceSubcategory') {
      this.categorydropdown();
    }
    if (this.action == 'AddProjectCategory' || this.action == 'EditProjectCategory') {
      let SBHDropDownLists = await this.SBHDropDown();
      this.SBHDropDownLists = SBHDropDownLists.Result;
    }
    setTimeout(() => {
      if(this.action == 'EditProjectCategory'){
        this.ProjectCategoryInput.CostCenterCategory = this.SBHDropDownLists.filter(x=>x.CostCenterCategoryId == this.ProjectCategoryInput.BusinessProcessId)[0] || {};
      }
    }, 1000);
    if (this.action == 'AddProjectType' || this.action == 'EditProjectType') {
      let ProjectTypeDropDownLists = await this.GetProjectCategoryDropDown();
      this.ProjectTypeDropDownLists = ProjectTypeDropDownLists;

      await this.hsnList();
    }
    if (this.action == 'AddServiceItems' || this.action == 'EditServiceItems') {
      let vendorServiceNameList = await this.GetvendorServiceNameList();
      this.vendorServiceNameList = vendorServiceNameList.Result.Data;
    }

  }
  compareFn(a: any, b: any) {
    if (b) {
      const d = a[Object.keys(a)[0]];
      const e = b[Object.keys(b)[0]];
      return d === e;
    }
  }
  async hsnList() {
  this.spinner.show();
  try {
    this.response = await this.coreservice.asyncPostService({}, 'HSNDropDownList', 'CompanyCore');
    if (this.response?.data?.Result) {
      this.HsnDropList = this.response.data.Result;
    }
  } catch (error) {
    console.error("Error fetching HSN List", error);
  } finally {
    this.spinner.hide();
  }
}

}

